/** Layout dimensions for the Clients admin page. */
export const CLIENTS_PAGE_LAYOUT_SIZES = {
  headerToContentGap: 32,
  headingToSubtitleGap: 8,
  columnGap: 12,
  leftPanelWidth: 320,
  panelPadding: 20,
  panelSectionGap: 16,
  toolbarControlHeight: 40,
  toolbarFieldRadius: 10,
} as const;

/** Height of one client row (name + member count); used for ResizeObserver page sizing. */
export const CLIENT_ROW_HEIGHT_PX = 52;

/** Reserved below the list when computing page size so pagination does not shrink the observed area. */
export const CLIENT_LIST_PAGINATION_HEIGHT_PX = 48;

export const MEMBER_ROWS_PER_PAGE_OPTIONS = [10, 25, 50] as const;
